<template>
  <div class="content-page shops">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addShop">新建商铺</el-button>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="shopList" style="width: 100%">
            <el-table-column label="商铺名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.shopName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="地址">
              <template slot-scope="scope">
                <div>{{ scope.row.shopAddress }}</div>
              </template>
            </el-table-column>
            <el-table-column label="联系方式">
              <template slot-scope="scope">
                <div>{{ scope.row.shopTel }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    type="primary"
                    @click="editShop(scope.$index)"
                    plain
                    >编辑</el-button
                  >
                  <el-button size="small" type="danger" @click="del(scope.row)" plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogBindShopVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      @close="resetForm"
    >
      <div slot="title" class="dialog-title">
        {{ shopForm.id ? "编辑商铺" : "新建商铺" }}
      </div>
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <div>
          <el-form-item label="商铺名称" prop="shopName">
            <el-input v-model="shopForm.shopName" placeholder="请填写商铺名称"></el-input>
          </el-form-item>
          <el-form-item label="所在地" prop="shopAddress">
            <el-cascader
              v-model="shopForm.cityName"
              @change="cityNameCascaderHandler"
              :options="cityOptions"
              :props="{ expandTrigger: 'hover', value: 'value' }"
              placeholder="请选择门店所在地"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="shopAddress">
            <el-input v-model="shopForm.shopAddress" placeholder="请填写商铺地址">
              <!-- <template slot="append">
                <el-button @click="showDialogMap">去定位</el-button>
              </template> -->
            </el-input>
          </el-form-item>
          <el-form-item label="经纬度:" prop="center">
            <el-input
              v-model="mapCenterInputText"
              placeholder="请填写经纬度"
              @blur="mapCenterInputTextBlur(shopForm)"
            >
              <template slot="append">
                <el-button type="primary" @click="showDialogMap()">去获取</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="shopTel">
            <el-input v-model="shopForm.shopTel" placeholder="请填写联系电话"></el-input>
          </el-form-item>
          <el-form-item label="排序序号">
            <el-input
              v-model="shopForm.indexNo"
              type="number"
              placeholder="请输入排序序号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商铺logo" prop="shopLogo">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'shopLogo');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'shopLogo');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="shopLogo"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'shopLogo')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="商标logo" prop="trademarkLogo">
            <div>
              <el-upload
                :disabled="uploadDisabled"
                action="/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (e) => {
                    handleRemove(e, 'trademarkLogo');
                  }
                "
                :http-request="
                  (e) => {
                    handleSuccess(e, 'trademarkLogo');
                  }
                "
                :before-upload="beforeImgUpload"
                :file-list="trademarkLogo"
                :on-exceed="limitTip"
                :limit="1"
              >
                <div
                  style="width: 148px; height: 148px; position: absolute"
                  @click="show_uploadDialog(1, 'trademarkLogo')"
                ></div>
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="商铺介绍" prop="shopDescription">
            <quill-editor
              class="editor"
              v-model="shopForm.shopDescription"
              ref="myQuillEditor"
              :options="editorOption"
              @change="onEditorChange($event)"
            />
            <input
              type="file"
              hidden
              accept=".jpg,.png"
              ref="fileBtn"
              @change="handleUpload"
            />
          </el-form-item>
          <el-form-item label="商店类型">
            <el-radio-group v-model="shopForm.storeType">
              <el-radio :label="1">餐饮</el-radio>
              <el-radio :label="2">培训</el-radio>
              <el-radio :label="3">娱乐</el-radio>
              <el-radio :label="4">购物</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="优惠信息" prop="offerInformation">
            <!-- <quill-editor
              class="editor"
              v-model="shopForm.offerInformation"
              ref="offerInfoEditor"
              :options="offerInfoEditorOption"
              @change="onEditorChange($event)"
            /> -->
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入优惠信息"
              v-model="shopForm.offerInformation"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('shopForm')" :loading="isSubmit">
          {{ shopForm.id ? "编辑" : "立即创建" }}</el-button
        >
        <el-button @click="dialogBindShopVisible = false">取 消</el-button>
      </div>
      <el-dialog
        width="510px"
        :visible.sync="dialogMapVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="true"
      >
        <div slot="title" class="dialog-title">地图定位</div>
        <!-- <baidu-map
          v-if="dialogMapVisible"
          class="map"
          :center="center"
          :zoom="zoom"
          @ready="mapReadyHandler"
          @click="getPoint"
          :scroll-wheel-zoom="true"
        >
          <bm-control :offset="{ width: '10px', height: '10px' }">
            <el-input v-model="keyword" placeholder="请输入地名关键字"></el-input>
          </bm-control>
          <bm-local-search
            :keyword="keyword"
            :auto-viewport="true"
            :location="location"
            zoom="12.8"
            style="display: none"
          ></bm-local-search>
          <bm-marker :position="postionMap">
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
              style="font-size: 14px"
            >
              <p>站点：{{ add.siteName }}</p>
              <p>站点地址：{{ add.site }}</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveStationAddress">保存</el-button>
        </div>
      </el-dialog>
      <!-- <baidu-map v-if="showMap" class="index-map"></baidu-map> -->
    </el-dialog>
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
  </div>
</template>

<script>
import {
  getTerraceShopInfo,
  addTerraceShop,
  getShopStoresTotalNum,
  getTerraceShopList,
  modifyTerraceShopInfo,
  deleteTerraceShop,
  uploadImg,
} from "@/api";
import uploadImgComponent from "@/components/uploadImg";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import { gg2bd, bd2gg } from "@/utils/map.js";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      shopList: [],
      isSubmit: false,
      pageNo: 1,
      pageSize: 5,
      pageCount: 0,
      dialogBindShopVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      shopForm: {
        shopLogo: "",
        trademarkLogo: "",
        shopName: "",
        shopTel: "",
        shopAddress: "",
        indexNo: "",
        shopDescription: "",
        storeType: 1,
        offerInformation: "",
        cityName: [],
        longitude: "",
        latitude: "",
        cityId: "",
        districtId: "",
        provinceId: "",
      },
      rules: {
        shopLogo: [
          {
            required: true,
            message: "请上传商铺LOGO",
            trigger: "blur",
          },
        ],
        trademarkLogo: [
          {
            required: true,
            message: "请上传商铺LOGO",
            trigger: "blur",
          },
        ],
        shopName: [
          {
            required: true,
            message: "请填写商铺名称",
            trigger: "blur",
          },
        ],
        shopAddress: [
          {
            required: true,
            message: "请填写商铺地址",
            trigger: "blur",
          },
        ],
        shopDescription: [
          {
            required: true,
            message: "请填写商铺介绍",
            trigger: "blur",
          },
        ],
        shopTel: [
          {
            required: true,
            message: "请填写联系电话",
            trigger: "blur",
          },
        ],
        offerInformation: [
          {
            required: true,
            message: "请填写优惠信息",
            trigger: "blur",
          },
        ],
      },
      isshow_uploadDialog: false,
      uploadDisabled: false,
      ImgLimits: 1,
      uploadName: "",
      shopLogo: [],
      trademarkLogo: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["image"],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
        },
        placeholder: "请填写商铺介绍",
      },
      offerInfoEditorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["image"],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
        },
        placeholder: "请填写优惠信息",
      },
      cityOptions: require("@/assets/js/cityData.json"),
      mapCenter: "",
      center: { lng: 0, lat: 0 },
      zoom: 12.8,
      dialogMapVisible: false,
      keyword: "",
      location: "",
      show: false,
      postionMap: {
        //地图坐标
        lng: 120.211486,
        lat: 30.256576,
      },
      add: {
        siteName: "",
        site: "",
        jd: "",
        wd: "",
        desce: "",
        type: "",
        jgName: "",
        jgNum: "",
      },
      showMap: false,
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  watch: {
    dialogBindShopVisible(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.myQuillEditor) {
            this.$refs.myQuillEditor.quill
              .getModule("toolbar")
              .addHandler("image", this.imgHandler);
          }
        });
      }
    },
  },
  components: {
    uploadImgComponent,
    quillEditor,
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData(type = "") {
      if (type == "create") {
        this.pageNo = Math.ceil((this.pageCount + 1) / this.pageSize);
      }
      this.getTerraceShopList();
    },
    imgHandler(state) {
      if (state) {
        this.$refs.fileBtn.click();
      }
    },
    getTerraceShopList() {
      getTerraceShopList({
        shoperUserId: localStorage.userId,
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.shopList = res.data.list;
          this.pageCount = res.data.totalCount;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    info(index) {},
    addShop() {
      let shopForm = JSON.parse(JSON.stringify(this.shopForm));
      shopForm.shopName = "";
      shopForm.shopAddress = "";
      this.shopForm = shopForm;
      this.dialogBindShopVisible = true;
    },
    editShop(ind) {
      getTerraceShopInfo({
        shopId: this.shopList[ind].shopId,
      }).then((shopInfo) => {
        let shopForm = JSON.parse(JSON.stringify(shopInfo.data));
        // let { lng, lat } = gg2bd(shopForm.longitude, shopForm.latitude);
        // let point = new BMap.Point(lng, lat);
        shopForm.cityName = shopForm.areaJson ? JSON.parse(shopForm.areaJson) : [];
        let cityName = "";
        let value = shopForm.cityName;
        if (value.length) {
          cityName += this.cityOptions[value[0] - 1].label;
          this.cityOptions[value[0] - 1].children.forEach((val) => {
            if (val.value == value[1]) {
              cityName += val.label;
              val.children.forEach((subval) => {
                if (subval.value == value[2]) {
                  cityName += subval.label;
                }
              });
            }
          });
        }
        this.mapCenter = cityName;
        this.shopLogo =
          shopForm.shopLogo && shopForm.shopLogo.length
            ? [{ url: shopForm.shopLogo }]
            : [];
        this.trademarkLogo =
          shopForm.trademarkLogo && shopForm.trademarkLogo.length
            ? [{ url: shopForm.trademarkLogo }]
            : [];

        this.shopForm = Object.assign(this.shopForm, shopForm);
        this.dialogBindShopVisible = true;
        //富文本编辑器神坑处理
        this.$nextTick(() => {
          this.$refs.myQuillEditor.quill.enable(true);
          this.$refs.myQuillEditor.quill.blur();
          // this.$refs.offerInfoEditor.quill.enable(true);
          // this.$refs.offerInfoEditor.quill.blur();
        });
        this.mapCenterInputText = `${shopForm.longitude},${shopForm.latitude}`;
        // let point = new BMap.Point(shopForm.longitude, shopForm.latitude);
        // let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
        // geocoder.getLocation(point, (rs) => {
        //   // shopForm.cityName = [
        //   //   rs.addressComponents.province,
        //   //   rs.addressComponents.city,
        //   //   rs.addressComponents.district,
        //   // ];
        // });
      });
    },
    getChoose_ImgUrl(val, name) {
      console.log(val, name);
      if (val.length > 0) {
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${item.image}`;
            } else {
              this.shopForm[name] = item.image;
            }
            this.shopImages.push({ name: "", url: item.image });
            return;
          }
          this.shopForm[name] = item.image;
          switch (name) {
            case "shopLogo":
              this.shopLogo = [];
              this.shopLogo.push({ name: "", url: item.image });
              break;
            case "trademarkLogo":
              this.trademarkLogo = [];
              this.trademarkLogo.push({ name: "", url: item.image });
              break;
            case "shopFaceImage":
              this.shopFaceImage = [];
              this.shopFaceImage.push({ name: "", url: item.image });
              break;
            case "bannerImage":
              this.bannerImage = [];
              this.bannerImage.push({ name: "", url: item.image });
              break;
            case "indexBackgroundImage":
              this.indexBackgroundImage = [];
              this.indexBackgroundImage.push({ name: "", url: item.image });
              break;
            default:
              console.log("111");
          }
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, name);
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          if (name == "shopImages") {
            if (this.shopForm[name].length) {
              this.shopForm[name] += `,${res.data.url}`;
            } else {
              this.shopForm[name] = res.data.url;
            }
            return;
          }
          this.shopForm[name] = res.data.url;
        }
      });
    },
    submitForm(formName, cb) {
      console.log(this.shopForm, "shopForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let shopForm = JSON.parse(JSON.stringify(this.shopForm));
          shopForm.shopId = shopForm.id;
          shopForm.areaJson = JSON.stringify(shopForm.cityName);
          if (shopForm.shopId) {
            modifyTerraceShopInfo(shopForm).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.dialogBindShopVisible = false;
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          } else {
            addTerraceShop(shopForm).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
                this.dialogBindShopVisible = false;
                this.getPageData("create");
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查商铺设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    limitTip(files, fileList) {
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeRemove(file, fileList) {},
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    resetForm() {
      this.shopForm = {
        shopLogo: "",
        trademarkLogo: "",
        shopName: "",
        shopTel: "",
        shopAddress: "",
        shopDescription: "",
        indexNo: "",
        storeType: 1,
        offerInformation: "",
      };
      this.shopLogo = [];
      this.trademarkLogo = [];
      this.mapCenterInputText = "";
      this.$refs.shopForm.resetFields();
    },
    del(item) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            deleteTerraceShop({
              shopId: item.shopId,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
    },
    handleUpload(e) {
      const file = e.target.files;
      if (!file) {
        return;
      }
      let imgUploadForm = new FormData();
      let sessionId = localStorage.getItem("sessionId");
      let userId = localStorage.getItem("userId");
      imgUploadForm.append("file", file[0]);
      // imgUploadForm.append("fileContentType", file.file.type);
      // imgUploadForm.append("fileFileName", file.file.name);
      // imgUploadForm.append("isCompre", 1);
      // imgUploadForm.append("isCutImage", 1);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      uploadImg(imgUploadForm).then((res) => {
        console.log(res, 789);
        if (res.code == 1) {
          let selection = this.$refs.myQuillEditor.quill.getSelection();
          //这里就是返回的图片地址，如果接口返回的不是可以访问的地址，要自己拼接
          let imgUrl = res.data.url;
          //获取quill的光标，插入图片
          this.$refs.myQuillEditor.quill.insertEmbed(
            selection != null ? selection.index : 0,
            "image",
            imgUrl
          );
          //插入完成后，光标往后移动一位
          this.$refs.myQuillEditor.quill.setSelection(selection.index + 1);
        }
      });
    },
    cityNameCascaderHandler(value) {
      if (!value) return;
      this.shopForm.provinceId = value[0];
      this.shopForm.cityId = value[1];
      this.shopForm.districtId = value[2] || -1;
      let cityName = "";
      cityName += this.cityOptions[value[0] - 1].label;
      this.cityOptions[value[0] - 1].children.forEach((val) => {
        if (val.value == value[1]) {
          cityName += val.label;
          if (val.children) {
            val.children.forEach((subval) => {
              if (subval.value == value[2]) {
                cityName += subval.label;
              }
            });
          }
        }
      });
      this.mapCenter = cityName;
    },
    // showDialogMap() {
    //   if (!this.shopForm.cityName) {
    //     this.$notify({
    //       title: "警告",
    //       message: "请先选择城市",
    //       type: "warning",
    //       duration: 6000,
    //     });
    //     return;
    //   }
    //   this.dialogMapVisible = true;
    // },
    mapReadyHandler({ BMap, map }) {
      this.center = this.mapCenter;
      this.zoom = 12.8;
    },
    saveStationAddress() {
      this.dialogMapVisible = false;
    },
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      setInterval(() => {
        this.show = true;
      }, 100);
    },
    getPoint(e) {
      //点击地图获取一些信息，
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();

      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.add.lng = rs.point.lng;
        this.add.lat = rs.point.lat;
        this.shopForm.shopAddress = rs.address;
        // let { lng, lat } = bd2gg(rs.point.lng, rs.point.lat);
        this.shopForm.longitude = rs.point.lng;
        this.shopForm.latitude = rs.point.lat;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .list {
    width: 100%;
    padding: 0 20px;
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
.popup-container {
  text-align: center;
  padding-bottom: 10px;
  .qrcode {
    display: block;
    margin: 10px;
  }
}
.demo-ruleForm {
  height: 500px;
  overflow: auto;
}
</style>

<style lang="less">
.shops {
  .quill-editor {
    line-height: 1;
    .ql-container {
      height: 360px;
    }
  }
}
</style>
